/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEnrollOTPResponse
 */
export interface ControlEnrollOTPResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlEnrollOTPResponse
     */
    barcode_uri: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEnrollOTPResponse
     */
    secret: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEnrollOTPResponse
     */
    recovery_code: string;
}

/**
 * Check if a given object implements the ControlEnrollOTPResponse interface.
 */
export function instanceOfControlEnrollOTPResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "barcode_uri" in value;
    isInstance = isInstance && "secret" in value;
    isInstance = isInstance && "recovery_code" in value;

    return isInstance;
}

export function ControlEnrollOTPResponseFromJSON(json: any): ControlEnrollOTPResponse {
    return ControlEnrollOTPResponseFromJSONTyped(json, false);
}

export function ControlEnrollOTPResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEnrollOTPResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'barcode_uri': json['barcode_uri'],
        'secret': json['secret'],
        'recovery_code': json['recovery_code'],
    };
}

export function ControlEnrollOTPResponseToJSON(value?: ControlEnrollOTPResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'barcode_uri': value.barcode_uri,
        'secret': value.secret,
        'recovery_code': value.recovery_code,
    };
}

